import * as actionTypes from '../actionTypes/WebSocket'

export const sendMessage = message => {
    return {
        type: actionTypes.SEND_MESSAGE,
        message,
    }
}

export const receiveChatMessage = chatMsg => {
    return {
        type: actionTypes.SET_CHAT_MSG,
        chatMsg,
    }
}

export const receiveTtmMessage = ttmMsg => {
    return {
        type: actionTypes.SET_TTM_MSG,
        ttmMsg,
    }
}

export const receiveRoomStateMessage = roomStateMsg => {
    return {
        type: actionTypes.SET_ROOM_STATE_MSG,
        roomStateMsg,
    }
}

export const receiveAudioMessage = audioMsg => {
    return {
        type: actionTypes.SET_AUDIO_MESSAGE,
        audioMsg,
    }
}

export const receiveNoteMessage = noteMsg => {
    return {
        type: actionTypes.SET_NOTE_MESSAGE,
        noteMsg,
    }
}

export const deleteNoteMessage = noteMsg => {
    return {
        type: actionTypes.DELETE_NOTE_MESSAGE,
        noteMsg,
    }
}

export const fetchNotesMessages = notesMessages => {
    return {
        type: actionTypes.FETCH_NOTES_MESSAGES,
        notesMessages,
    }
}

export const populateDummyNotesMessages = notesMessages => {
    return {
        type: actionTypes.POPULATE_DUMMY_NOTES_MESSAGES,
        notesMessages,
    }
}

export const setSenderIdForDummyNotes = userId => {
    return {
        type: actionTypes.SET_SENDER_ID_FOR_DUMMY_NOTES,
        userId,
    }
}

export const receiveAllMessage = msg => {
    return {
        type: actionTypes.SET_ALL_MSG,
        msg,
    }
}

export const setSocket = socket => {
    return {
        type: actionTypes.SET_SOCKET,
        socket,
    }
}

export const sendSocketMessage = socketMsg => {
    return {
        type: actionTypes.HANDLE_SEND_SOCKET_MESSAGE,
        socketMsg,
    }
}

export const wsConnect = host => ({ type: 'WS_CONNECT', host })
export const wsConnecting = host => ({ type: 'WS_CONNECTING', host })
export const wsConnected = host => ({ type: 'WS_CONNECTED', host })
export const wsDisconnect = host => ({ type: 'WS_DISCONNECT', host })
export const wsDisconnected = host => ({ type: 'WS_DISCONNECTED', host })

//Helper actions
export const setError = message => {
    return {
        type: actionTypes.SET_ERROR_MESSAGE,
        message,
    }
}

export const resetStateRequest = () => ({
    type: actionTypes.RESET_WEB_SOCKET_STATE,
})

export const resetGeneralMessages = () => ({
    type: actionTypes.RESET_GENERAL_MESSAGES,
})

export const setIsIframeShared = data => ({
    type: actionTypes.SET_IS_IFRAME_SHARED,
    data,
})
